import { Link } from "gatsby";
import { PropsWithChildren } from "react";
import { textLink, textLinkNoUnderline } from "./styles.css";
import classNames from "classnames";

export const TextLink = ({
  to,
  children,
  isExternal,
  onClick,
  className: _className,
  style,
  sameTab,
  noUnderline,
}: PropsWithChildren<
  {
    to?: string;
    isExternal?: boolean;
    onClick?: () => void;
    sameTab?: boolean;
    noUnderline?: boolean;
  } & StyledProps
>) => {
  const className = classNames(textLink, _className, {
    [textLinkNoUnderline]: noUnderline,
  });

  if (!to) {
    return (
      <a className={className} onClick={onClick}>
        {children}
      </a>
    );
  }

  if (to.startsWith("mailto:")) {
    return (
      <a className={className} style={style} href={to} onClick={onClick}>
        {children}
      </a>
    );
  }

  return isExternal ? (
    <a
      className={className}
      style={style}
      target={!sameTab ? "_blank" : undefined}
      href={to}
      onClick={onClick}
    >
      {children}
    </a>
  ) : (
    <Link
      className={className}
      style={style}
      to={to}
      onClick={onClick}
      state={{ type: "text-link" }}
    >
      {children}
    </Link>
  );
};
